<template>
  <b-nav-item-dropdown variant="link" menu-class="pb-0 px-2 pt-2" no-caret>
    <template #button-content>
      <div class="d-flex align-items-center">
        <feather-icon icon="EyeIcon" size="18" class="mr-50"/>
        Options
        <feather-icon icon="ChevronDownIcon" size="14"/>
      </div>
    </template>

    <draggable
      :list="columns"
      draggable=".draggable"
      tag="div"
      :style="{width: columnCount * 200 + 'px'}"
      style="max-height: 500px"
      class="d-flex flex-column d-flex flex-column flex-wrap"
    >
      <b-form-checkbox
        class="mb-2 draggable"
        v-for="column in columns"
        :key="column.key"
        @change="$set(column, 'show', !column.show)"
        :checked="column.show"
      >
        {{ column.label }}
      </b-form-checkbox>
    </draggable>
  </b-nav-item-dropdown>

</template>

<script>
import {BCol, BRow, BNavItemDropdown, BFormCheckbox} from 'bootstrap-vue'
import Draggable from 'vuedraggable'

export default {
  components: {
    BCol,
    BRow,
    BNavItemDropdown,
    BFormCheckbox,
    Draggable

  },
  props: {
    columns: {
      type: Array,
      default: []
    },
  },
  computed: {
    columnCount() {
      return Math.ceil(this.columns.length / 12) || 1
    },
  },
}
</script>